module.exports = __webpack_public_path__ + "img/biaoti3.19ccc6ae.png";